module.exports = __webpack_public_path__ + "static/media/bg_request_chat.07aceebe.gif";